"use client";

import { Button, type ButtonProps } from "@/components/dubai/ui/button";
import { CONSULTATION_URL } from "@/lib/consultation-links";

export function BookingCta({ children, ...buttonProps }: ButtonProps) {
  return (
    <Button asChild {...buttonProps}>
      <a href={CONSULTATION_URL}>{children}</a>
    </Button>
  );
}
